import React from 'react';

import type { RecommendedArticlesBlockProps } from '../interfaces';
import ArticleItem from './ArticleItem';

const RecommendedArticlesBlock = ({ recommendedArticles }: RecommendedArticlesBlockProps) => {
  return (
    <article className="recommended-articles-block mt-64 sm:mt-96 md:mt-112">
      <header>
        <h2 className="m-0 text-center font-suisse-works text-headline-xs sm:text-headline-md lg:text-headline-lg">
          Recommended Articles
        </h2>
      </header>
      <div className="mt-32 flex flex-col justify-center sm:mt-48 sm:flex-row sm:flex-wrap sm:gap-48 lg:flex-nowrap">
        {recommendedArticles.map((article) => (
          <ArticleItem key={article.id} article={article} />
        ))}
      </div>
    </article>
  );
};

export default RecommendedArticlesBlock;
